export function getOpenInfoboxAliases(snsLive) {
    return new Set(
        snsLive
            .map((item) => item?.alias)
            .filter(Boolean)
    );
}

export function cleanupFollowForClosedInfoboxes(states, openAliases) {
    if (!states) {
        return states;
    }

    let changed = false;
    const next = { ...states };

    Object.keys(next).forEach((alias) => {
        if (next[alias] === true && !openAliases.has(alias)) {
            next[alias] = false;
            changed = true;
        }
    });

    return changed ? next : states;
}

export function getActiveFollowAlias(infoboxStates, openAliases) {
    return Object.entries(infoboxStates || {}).find(
        ([alias, active]) => active === true && openAliases.has(alias)
    )?.[0] ?? null;
}

export function isFollowDisabledForAlias(currentAlias, activeFollowAlias) {
    return activeFollowAlias !== null && activeFollowAlias !== currentAlias;
}

export function isAnyOtherWindyFollowActive(currentAlias, infoboxStates, infoboxStatesSimu, openAliases) {
    const hasOtherPrima = Object.entries(infoboxStates || {}).some(
        ([alias, active]) => active === true && alias !== currentAlias && openAliases.has(alias)
    );

    const hasOtherTerza = Object.entries(infoboxStatesSimu || {}).some(
        ([alias, active]) => active === true && alias !== currentAlias && openAliases.has(alias)
    );

    return hasOtherPrima || hasOtherTerza;
}
